import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styled from 'styled-components'
import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Footer from '../../components/Footer/Footer';
import H2 from '../../collections/H2/H2';
import Paragraph from '../../collections/Paragraph/Paragraph';
import {media} from "../../utilities/style-utilities";

const TextBox = styled.div`
    padding:20px;
`;

const SuccessWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 964px;
  background-color: white;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 300px;
  z-index: 1;
  margin-top: ${ props => props.overlay === false ? '8rem' :  '16rem' };
  margin-bottom: 2rem;
  border-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);

  ${ media.desktop`
    margin: 1rem;
  `}
`;

const SuccessImage = styled.div`
     background-size:contain;
     background-position: center;
     width:50%;
     height: 100%;
     width: 100%;
     margin: 15px auto;
     max-height: 300px;
     background-repeat: no-repeat;
    ${media.desktop`
         background-position: top;
         background-size:cover;  
    `}
`;

class SuccessEmailPage extends Component {
    render(){
        const successBackground = {
            backgroundImage: `url("${this.props.appState.ui.successEmail.imageSrc}")`,
            height: '250px',
        };

        const headerStyles = {
            textAlign:'center',
            fontSize: '30px',
            lineHeight: 'unset'
        };

        const captionStyles = {
            textAlign:'center',
        };

if(this.props.location.state !== undefined) {
    return (
        <Fragment>

            <Helmet>
                {/* props.appState.ui.terms.meta.title */}
                <title>{`Incentive Award Card`}</title>
                <meta name="description" content={`props.appState.ui.terms.meta.description`} />
            </Helmet>

            <Header header={this.props.appState.ui.header} url={this.props.url}/>
            <Main site={this.props.appState.ui.site} >
                {/* props.appState.ui.terms.card.titleText */}
                <SuccessWrapper>
                    <SuccessImage style={successBackground}></SuccessImage>
                    <TextBox>
                        <H2 style={headerStyles}>{this.props.location.state.title}</H2>
                        <Paragraph style={captionStyles} dangerouslySetInnerHTML ={{__html: this.props.location.state.description}} />
                    </TextBox>
                </SuccessWrapper>
            </Main>
            <Footer footer={this.props.appState.ui.footer} url={this.props.url} clientTerms={this.props.appState.ui.clientTerms}/>

        </Fragment>
    );
}else{
    return  <Redirect to='/not-found'  />;
}

    }
}

export default SuccessEmailPage;


// WEBPACK FOOTER //
// ./src/containers/SuccessEmailPage/SuccessEmailPage.js